/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import CartSidebar from '../CartSidebar'

import StartTabModal from '../../containers/tabs/StartTabModal'
import confirmationNotification from '../../hooks/useConfirmationNotification'

const TabsCartSidebar = ({ onMount, onUnmount, onTopButtonTap, onBottomButtonTap, hasCartItems, isNewOrder, order, className }) => {
  const [showModal, setShowModal] = useState(false)
  useEffect(() => onMount(), [])
  useEffect(() => () => onUnmount(), [])

  const tabText = isNewOrder ? "Start A Tab" : "Keep Tab Open"

  const topButton = {
    text: tabText,
    disabled: !hasCartItems,
    onClick: () => {
      if (isNewOrder) {
        setShowModal(true)
      } else {
        confirmationNotification(onTopButtonTap, order?.frozen)
      }
    }
  }

  let bottomButton = {
    text: "Pay Now",
    disabled: !hasCartItems,
    onClick: () => confirmationNotification(() => onBottomButtonTap(), order?.frozen)
  }

  if (!isNewOrder) {
    bottomButton = null
  }

  return (
    <>
      <CartSidebar
        topButton={topButton}
        bottomButton={bottomButton}
        hasCartItems={hasCartItems}
        order={order}
        className={className}
      />
      {showModal && <StartTabModal title={tabText} show onClose={() => setShowModal(false)} />}
    </>
  )
}

TabsCartSidebar.defaultProps = {
  onMount: () => {},
  onUnmount: () => {},
  onTopButtonTap: () => {},
  onBottomButtonTap: () => {},
  hasCartItems: false,
  isNewOrder: true,
  order: {},
}

TabsCartSidebar.propTypes = {
  onMount: PropTypes.func,
  onUnmount: PropTypes.func,
  onTopButtonTap: PropTypes.func,
  onBottomButtonTap: PropTypes.func,
  hasCartItems: PropTypes.bool,
  isNewOrder: PropTypes.bool,
  order: PropTypes.object,
}

export default withRouter(TabsCartSidebar)
